import {
  AppBar,
  Avatar,
  Breadcrumbs,
  Button,
  Divider,
  IconButton,
  ListItem,
  MenuItem,
  Popover,
  Toolbar,
  Typography,
} from '@material-ui/core';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { ArrowRight } from '@material-ui/icons';
import MenuIcon from '@material-ui/icons/Menu';
import { Skeleton } from '@material-ui/lab';
import { get } from 'lodash';
import Link from 'next/link';
import { useRouter } from 'next/router';
import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import restApi from '../../api/restApi';
import QLogo from '../../assets/images/quattr_logo_white.png';
import { QwaSession, QwaUser } from '../../auth/types';
import { actionTypes } from '../../constants/actionTypes';
import { GOOGLE_FETCH_FAVICON_API, SUBSCRIPTION_STATUS } from '../../constants/common';
import { CUSTOM_RANGE } from '../../constants/formMeta/growthTrends';
import { sidebarDefaultAiSeoNavs, SidebarNav, sideBarNavs } from '../../constants/navigationMeta';
import { storeSegmentData, storeCustomerInfo } from '../../utility/services/indexedDB/trends/storeTrendsMasterData';
import { fetchCustomerInfo, fetchSegmentData } from '../../utility/services/indexedDB/trends/fetchTrendsMasterData';

import {
  appendHttpsIfNotPresent,
  getAvatarInitials,
  getLogo,
  processSubscriptionData,
  RemoveLastUrlPartOf,
  USER_CLASSIFICATION,
} from '../../utility/common';
import { getSchema, getTestDriveDomain, signOut } from '../../utility/services/authActions';
import { useQalert } from '../../utility/services/customHooks';
import {
  useIsInternalUser,
  useIsSubscriberUser,
  useIsTestDriveUser,
  useSchema,
  useSession,
  useTestDriveDomain,
} from '../../utility/services/customHooks/auth';
import Utility from '../../utility/services/utility';
import { DateRangePicker, FormDropDown } from '../formElements';
import CollapsibleListItem from '../formElements/src/CollapsibleListItem';

import { excludeCustomerList, excludeNavigateURLList } from '../../constants/navigationMeta';
import { useRollbar } from '@rollbar/react';
import axios from 'axios';
import { setAmplitudeInstance, segmentEventApi } from '../../constants/analyticsMeta';
import { string } from 'yargs';
import ManageSubscriptions from '../shared/quattr-actions/components/ManageSubscriptions';
import {
  dispatchCustomerInfoQuery,
  dispatchCRListDataQuery,
  dispatchMasterDataQuery,
} from '../../utility/services/api/common';
import { mapPaidAndOrgData, removeViewNameFromChartsData } from '../../utility/common';
import fetchAndStoreCRData from '../../utility/services/indexedDB/content-recommendations/fetchAndStoreCRData';
import { TOOLS_INSTRUCTION_DETAILS } from '../../utility/tools-config';
import CreditsComponent from './CreditsComponent';
const breadcrumbMeta = {
  'all-boards': 'All Boards',
  'my-analysis': 'My Analysis',
  favorites: 'Favorites',
};

// AUTH0_TODO optimize useEffects
export default function Header(props) {
  const { isEnterpriseUser, userType } = props;
  const [defaultUser, setDefaultUser] = React.useState(props.defaultUser || USER_CLASSIFICATION.QWA_TOOLS);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState<Element | null>(null);
  const [userName, setUserName] = React.useState('');
  const router = useRouter();
  const dispatch = useDispatch();
  const exploresArray = useSelector((state) => state.root.explores);
  const looksList = useSelector((state) => state.root.looksList);
  const dashboardsList = useSelector((state) => state.root.dashboardsList);
  const customerInfo = useSelector((state) => state.root.customerInfo || []);
  const schemaName = useSchema();
  const customerData = customerInfo.find((o) => o.cust_code === schemaName);
  const loadersArray = useSelector((state) => state.root.loadersArray);
  const [accountsList, setAccountList] = React.useState<any[]>([]);
  const [showCustomerInfo, setShowCustomerInfo] = React.useState(false);
  const [subscriberMeta, setSubscriberMeta] = React.useState<any>({});
  const [redirected, setRedirected] = React.useState(false);
  const { pathname } = router;
  const { session, authState } = useSession();
  let qwaUser: QwaUser | undefined = undefined;
  let schemaList: string[] = [];

  if (session?.user) {
    qwaUser = session.user;
    schemaList = qwaUser.groups || [];
  }
  const isTestDriveUser = useIsTestDriveUser();
  const testDriveDomain = useTestDriveDomain();

  const [schemaIndex, setSchemaIndex] = React.useState(-1);
  const [hasCrListCalledAPI, setHasCrListCalledAPI] = React.useState(false);

  const rollbar = useRollbar();
  const filter = useSelector((state) => state.root.datePickerFilter);
  const paths = [
    '/app/trends/competitive-trends/[id]',
    '/app/trends/growth-trends/[id]',
    '/app/trends/competitive-trends',
    '/app/trends/growth-trends',
    'app/ranking-factors',
  ];
  const showGlobalDatePicker = (paths, pathName) => paths.some((path) => pathName.includes(path));
  const showDatePicker = showGlobalDatePicker(paths, router.pathname);
  const [, toggleSnackBar] = useQalert();
  const [userSelectedDateRange, setUserSelectedDateRange] = React.useState();
  const dateRangekey =
    String(filter.isTopTrendDetails) +
    String(filter.isSiteDetail) +
    String(filter.isUsabilityRecommendaton) +
    String(filter.isRankingFactor);

  const handleDrawerOpen = () => {
    props.toggleDrawer(!props.open);
  };

  const handleDropDownclickSchema = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handleLogout = async () => {
    /**
     * https://next-auth.js.org/getting-started/client#using-the-redirect-false-option-1
     */
    // will redirect to homepage via NextJS's router);
    const signOutPromise = signOut();
    if (window.analytics) {
      window.analytics.track('Logout');
    } else {
      segmentEventApi('Logout', null, 'track');
    }
    return await signOutPromise;
  };

  const showCustomerInformation = useCallback((customerInfo) => {
    let tempCustList: { title: string; cust_name: string }[] = [];
    const childCustomers = customerInfo.filter((i) => i.cust_child_name);

    customerInfo.forEach((cust) => {
      if (!tempCustList.find((i) => i.title == cust.cust_name) && !cust.cust_child_name) {
        // customer is not already added and should not be the child
        if (childCustomers.find((i) => i.cust_name == cust.cust_name)) {
          // check if customer has a child
          const obj = {
            title: cust.cust_name,
            listItems: childCustomers.filter((i) => i.cust_name == cust.cust_name),
            ...cust,
          };
          tempCustList.push(obj);
        } else {
          tempCustList.push(cust);
        }
      }
    });
    tempCustList = tempCustList.sort((a, b) => {
      let fa = a.cust_name.toLowerCase(),
        fb = b.cust_name.toLowerCase();

      if (fa < fb) {
        return -1;
      }
      if (fa > fb) {
        return 1;
      }
      return 0;
    });
    setAccountList(tempCustList);

    setShowCustomerInfo(true);
  }, []);

  const setAmplitudeSegmentEvents = async (payload) => {
    if (window.analytics) {
      window.analytics.identify(payload?.email, {
        email: payload.email,
        name: payload.email,
        schema: payload.schema,
        instance_type: payload.instance_type,
        user_type: payload.user_type,
        company_name: payload.company_name,
      });
      setAmplitudeInstance(payload.email);
    } else {
      axios.post(`${process.env.NEXT_PUBLIC_QUATTR_API_URL}/segment/identify`, payload);
    }
  };

  const fetchHeaderCustomerInfo = useCallback(
    async (customerInfo, testDriveDomain?: string, session?: QwaSession) => {
      const schemaName = await getSchema(session);
      if (session?.user?.userType !== USER_CLASSIFICATION.QWA_TOOLS) {
        try {
          let response: { data: any[] }, segmentFiltersRes: { market_share_segment: any; domain: any };
          // Need in future
          // const dataFromIndexDB = await checkIndexDBData();
          // if (dataFromIndexDB) {
          //   response = dataFromIndexDB?.response;
          //   segmentFiltersRes = dataFromIndexDB?.segmentFiltersRes;
          //   Promise.allSettled([
          //     dispatchCustomerInfoQuery(dispatch),
          //     dispatchMasterDataQuery(dispatch, ['domain', 'market_share_segment']),
          //   ]).then((results) => {
          //     results?.forEach((result, index) => {
          //       if (result.status === 'fulfilled') {
          //         if (index === 0) {
          //           storeCustomerInfo(result.value, schemaName);
          //         } else if (index === 1) {
          //           storeSegmentData(result.value, schemaName);
          //         }
          //       } else {
          //         console.error('Silent execution failed:', result?.reason);
          //       }
          //     });
          //   });
          // } else {
          [response, segmentFiltersRes] = await Promise.all([
            dispatchCustomerInfoQuery(dispatch),
            dispatchMasterDataQuery(dispatch, ['domain', 'market_share_segment']),
          ]);
          // }

          //
          // useSchema returns undefined on initial render.
          // schemaName is not state hence fetchHeaderCustomerInfo do not get defined with new schemaName
          let index = response.data.findIndex((data) => {
            return data.cust_code == schemaName;
          });

          index = index == -1 ? 0 : index;
          let defaultDomain = get(response, `data[${index}].domain_url`) || '';
          const lastChar = defaultDomain.substr(-1); // Selects the last character
          if (lastChar != '/') {
            // If the last character is not a slash
            defaultDomain = defaultDomain + '/'; // Append a slash to it.
          }

          if (testDriveDomain && segmentFiltersRes.market_share_segment) {
            const allMarketSegments = segmentFiltersRes.market_share_segment;
            const subscribersMkSegment = allMarketSegments.find(
              (i) => i.segment_id && i.segment_id === testDriveDomain
            );
            defaultDomain = testDriveDomain;
            if (subscribersMkSegment) {
              dispatch({
                type: actionTypes.SET_MARKET_SEGMENT,
                defaultMarketSegment: [
                  {
                    text: subscribersMkSegment.segment_name,
                    value: subscribersMkSegment.segment_id,
                    type: 'market_share_segment',
                    defaultApplied: true,
                  },
                ],
              });
            }
          }

          if (defaultDomain || segmentFiltersRes.domain) {
            dispatch({
              type: actionTypes.SET_DOMAIN,
              defaultDomain: defaultDomain || get(segmentFiltersRes, 'domain[0].top_data'),
            });
          }
          if (response.data) {
            dispatch({
              type: actionTypes.SET_CUSTOMER_INFO,
              customerInfo: response.data,
            });
            setSchemaIndex(index);
            if (customerInfo && customerInfo.length) {
              showCustomerInformation(customerInfo);
            }
          }
        } catch (error) {
          console.log('Header :: fetchHeaderCustomerInfo :: Error ::', error);
        } finally {
          dispatch({
            type: actionTypes.REMOVE_LOADER,
            loaderName: 'CUSTOMER_INFO',
          });
        }
      }
    },
    [dispatch, showCustomerInformation, schemaName]
  );

  const checkIndexDBData = async () => {
    const promiseArrIndexDB = [fetchCustomerInfo(schemaName), fetchSegmentData(schemaName)];
    const promiseResIndexDB = await Promise.all(promiseArrIndexDB);
    const [response, segmentFiltersRes] = promiseResIndexDB;
    if (segmentFiltersRes && response) {
      return {
        response,
        segmentFiltersRes,
      };
    }
    return null;
  };

  const openSchema = Boolean(anchorEl2);

  useEffect(() => {
    // TODO_AUTH0 fix error loop
    // console.log('in useEffect 1');
    // avoid running before we have a session
    if (session === undefined) {
      return;
    }

    if (customerInfo && customerInfo.length) {
      const index = customerInfo.findIndex((data) => {
        return data.cust_code == schemaName;
      });
      setSchemaIndex(index == -1 ? 0 : index);
      showCustomerInformation(customerInfo);
    } else {
      if (!loadersArray.includes('CUSTOMER_INFO')) {
        dispatch({
          type: actionTypes.ADD_LOADER,
          loaderName: 'CUSTOMER_INFO',
        });
        // Question: Why are we passing customerInfo if its not present
        fetchHeaderCustomerInfo(customerInfo, testDriveDomain, session);
      }
    }
  }, [
    customerInfo,
    dispatch,
    fetchHeaderCustomerInfo,
    loadersArray,
    schemaName,
    session,
    showCustomerInformation,
    testDriveDomain,
  ]);

  const isInternal = useIsInternalUser();
  const isSubscriber = useIsSubscriberUser();
  React.useEffect(() => {
    // TODO_AUTH0 fix error loop
    // console.log('in useEffect 2');
    // we don't want analytics to crash the entire session, so try/catch
    try {
      if (customerInfo && qwaUser?.email && customerInfo.length && window.analytics) {
        const index = customerInfo.findIndex((data) => {
          return data.cust_code === schemaName;
        });
        const schemaInfo = customerInfo[index];
        const isContentAIUser =
          schemaInfo?.sidebar_link_config && schemaInfo?.sidebar_link_config['is-content-enabled-only'];
        const instance_type = schemaInfo?.additional_user_info?.isDemoUser
          ? 'Sandbox'
          : isSubscriber
          ? 'Test Drive'
          : isContentAIUser
          ? 'Content AI'
          : 'Full Tenant';
        const user_type =
          isContentAIUser && !isInternal
            ? 'Free Trial'
            : isSubscriber && !isInternal
            ? 'Prospect'
            : isInternal
            ? 'Internal'
            : 'Customer';
        const user_email = qwaUser.email;
        const companyName = isSubscriber ? qwaUser?.name : schemaInfo?.cust_name;
        const payload = {
          email: user_email,
          name: user_email,
          schema: schemaInfo?.cust_code,
          instance_type: instance_type,
          user_type: user_type,
          company_name: companyName,
        };
        //set identify event at amplitude and segment based on windows analaytics
        setAmplitudeSegmentEvents(payload);
      }
    } catch (error) {
      rollbar.error(`Header: Analytics failed to save`, { error });
    }
  }, [customerInfo, isInternal, isSubscriber, qwaUser?.email, qwaUser?.name, rollbar, schemaName]);

  useEffect(() => {
    // TODO_AUTH0 fix error loop
    // console.log('in useEffect 3');
    if (isTestDriveUser && testDriveDomain) {
      setUserName(testDriveDomain);
    } else if (qwaUser?.name) {
      if (qwaUser.subscription_status) {
        // purposefully logged
        console.log('qwaUser.subscription_status => ', qwaUser.subscription_status);
      }
      setUserName(qwaUser?.name);
    }
  }, [isTestDriveUser, qwaUser, testDriveDomain]);

  //TO BE ADDED LATER
  // useEffect(() => {
  //   const fetchCRData = async () => {
  //     console.log('Calling header fetchCRData');
  //     console.log('Calling header fetchCRData hasCrListCalledAPI', schemaName, hasCrListCalledAPI);
  //     if (schemaName && !hasCrListCalledAPI) {
  //       const forceRefetch = true;
  //       const filterPayload = {
  //         filtersObj: {},
  //         limit: 20000,
  //         isPagination: true,
  //         dataSource: 'organic',
  //         resetCache: true,
  //       };

  //       try {
  //         // Dispatch the query without waiting
  //         dispatchCRListDataQuery(dispatch, filterPayload, forceRefetch)
  //           .then((response) => {
  //             console.log('Calling header fetchCRData got response');
  //             // Store data in IndexedDB asynchronously
  //             const sortedData = mapPaidAndOrgData(removeViewNameFromChartsData(response?.data?.crPagesList));
  //             localStorage.setItem(`content-recommendations-list-cachedAt${schemaName}`, response?.data?.cachedAt);
  //             fetchAndStoreCRData(sortedData, schemaName)
  //               .then(() => {
  //                 console.log('Calling header fetchCRData got response and fetchAndStoreCRData');
  //                 // Update the state to indicate API call has been made
  //                 setHasCrListCalledAPI(true);
  //               })
  //               .catch((error: any) => {
  //                 console.error('Failed to store data in IndexedDB', error);
  //               });
  //           })
  //           .catch((error) => {
  //             console.error('Failed to fetch data', error);
  //           });
  //       } catch (error) {
  //         console.error('Error while fetching and storing data', error);
  //       }
  //     }
  //   };

  //   // Call the async function
  //   fetchCRData();
  // }, [schemaName, hasCrListCalledAPI, session, dispatch, setHasCrListCalledAPI]);

  useEffect(() => {
    if (customerData && customerData.SubscriberUserDetails) {
      const _subscriberMeta = processSubscriptionData(customerData);
      setSubscriberMeta(_subscriberMeta);
      if (_subscriberMeta && _subscriberMeta.isInTrial) {
        dispatch({
          type: actionTypes?.SET_SHOW_SUBSCRIPTION_BANNER,
          showSubscriberBanner: _subscriberMeta?.customer_id,
        });

        dispatch({
          type: actionTypes?.SET_SUBSCRIBER_META,
          subscriberMeta: _subscriberMeta,
        });
      }
    }
  }, [customerData, dispatch]);

  const updateDatePickerParams = (params, showDatePicker) => {
    //set user selected date range in store to trigger filter method and call looker API
    dispatch({
      type: actionTypes.SET_USER_SELECTED_DATE_RANGE,
      userSelectedDateRange: { params: params, showDatePicker: showDatePicker },
    });
  };

  const updateDateRange = (params) => {
    dispatch({
      type: actionTypes.SET_DEFAULT_DATE_RANGE,
      defaultDateRange: params,
    });
  };

  const showPeriodDoesNotMatchWarning = (selectedDateObj, comparisonDateObj) => {
    const { is_date_comparison, date_granularity } = filter.filters;

    if (is_date_comparison == 'Yes') {
      let selectionPeriodCount = 0,
        comparisonPeriodCount = 0;

      selectionPeriodCount = Utility.getDiffAsPerGranularityType(
        date_granularity,
        selectedDateObj.startDate,
        selectedDateObj.endDate
      );
      comparisonPeriodCount = Utility.getDiffAsPerGranularityType(
        date_granularity,
        comparisonDateObj.startDate,
        comparisonDateObj.endDate
      );

      if (selectionPeriodCount != comparisonPeriodCount) {
        toggleSnackBar({
          type: 'warning',
          open: true,
          text: `Number of ${date_granularity} in selected and comparison periods do not match`,
        });
      }
    }
  };

  const setDateRanges = (dateRanges) => {
    setUserSelectedDateRange(dateRanges);
    showPeriodDoesNotMatchWarning(dateRanges.selected, dateRanges.comparison);
    updateDateRange(dateRanges);
  };

  const containsDynamicRoute = pathname.includes('[name]') || pathname.includes('[id]');
  const showBreadCrumb = pathname.includes('/app/adhoc-analysis/');
  let dynamicRouteTitle = '';

  if (pathname.includes('[name]') && exploresArray.length) {
    const lookData = exploresArray.find((i) => i.name == router.query.name);
    dynamicRouteTitle = lookData ? lookData.label : '';
  } else if (pathname.includes('/dashboard/[id]') && looksList.length) {
    const lookData = dashboardsList.find((i) => i.id == router.query.id);
    dynamicRouteTitle = lookData ? lookData.title : '';
  } else if (pathname.includes('[id]') && looksList.length) {
    const lookData = looksList.find((i) => i.id == router.query.id);
    dynamicRouteTitle = lookData ? lookData.title : '';
  }

  let allNavs: SidebarNav[] = [];
  sideBarNavs.forEach((i) => {
    allNavs = [...allNavs, ...(i.subNavs || [])];
  });
  let matchUrl = containsDynamicRoute ? RemoveLastUrlPartOf(router.pathname, 2) : router.pathname;
  let currentNav = allNavs.find((i) => i.to === matchUrl);
  if (!currentNav) {
    matchUrl = containsDynamicRoute ? RemoveLastUrlPartOf(router.pathname, 1) : router.pathname;
    currentNav = allNavs.find((i) => i.to === matchUrl);
  }

  useEffect(() => {
    // TODO_AUTH0 fix unending error loop due to useEffects and useCallbacks
    // need these logs to track the sequence
    // console.log('in useEffect 4');
    if (!redirected) {
      const sideBarConfigHeader = customerInfo[schemaIndex]?.sidebar_link_config;
      //for ai tools users
      if (sideBarConfigHeader == undefined && props?.getUserType === USER_CLASSIFICATION.QWA_TOOLS) {
        const redirectUrl = '/app/ai-tools-home';
        if (
          ![
            '/app/ai-tools-home',
            '/app/content-ai-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits',
          ].includes(router.pathname)
        ) {
          setRedirected(true);
          router?.push(redirectUrl);
        }
      } else if (sideBarConfigHeader !== undefined) {
        const routeLinks = sideBarNavs?.flatMap((item) =>
          item.subNavs
            ?.filter((subNav) => sideBarConfigHeader[subNav?.uniqueKey as keyof typeof sideBarConfigHeader])
            .map((subNav) => subNav.to)
        );

        //for non content ai customers
        if (!sideBarConfigHeader['is-content-enabled-only']) {
          // exceptional page scenario where page is not in nav list
          routeLinks.push(
            '/app/manage-queries/query-classification-rules',
            '/app/spike',
            '/app/manage-categories/classify-pages',
            '/app/ai-tools-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits',
            '/app/settings/setup',
            '/app/settings/admin/schema'
          );
        }
        //for content ai customers
        if (sideBarConfigHeader['is-content-enabled-only']) {
          // exceptional page scenario where page is not in nav list
          routeLinks.push(
            '/app/content-ai-home',
            '/app/ai-seo-suite-home',
            '/app/ai-tools-home',
            '/app/ai-tools/[toolDetails]',
            '/app/manage-account',
            '/app/add-credits'
          );
        }

        if (!redirected && routeLinks && typeof window !== undefined) {
          const shouldRedirect = routeLinks !== undefined ? true : false;
          const targetURL =
            routeLinks[0] === '/app/manage-lists/keywords-list' ? '/app/content-ai-home' : routeLinks[0];
          // const targetURL = sideBarConfigHeader?.['is-content-enabled-only'] ? '/app/content-ai-home' : '/app/trends/growth-trends';
          const baserouterLinks = routeLinks?.filter(Boolean)?.map((url) => url?.split('?')[0]) ?? [];
          const containsSimilar = baserouterLinks?.some((link) => router?.pathname?.includes(link ?? ''));
          // redirect to target url if paid content recommendation page for content ai customer only
          const isPaidRecommendation = router?.query?.type === 'paid' && sideBarConfigHeader['is-content-enabled-only'];
          if (shouldRedirect && targetURL) {
            if (router?.pathname !== targetURL) {
              if (!containsSimilar || isPaidRecommendation) {
                router?.push(targetURL);
                setRedirected(true); // Set the state to prevent further redirections
              }
            }
          }
        }
      }
    }
  }, [allNavs, customerInfo, redirected, router, router?.pathname, schemaIndex]);

  //redirect to the oragnic recomemndation for specific customer once loggedin
  if (schemaName && excludeCustomerList?.includes(schemaName) && !excludeNavigateURLList?.includes(router?.pathname)) {
    window.location?.replace('/app/content-recommendations?type=organic');
  }

  const changeSchema = useCallback(
    async (schemaName) => {
      try {
        dispatch({
          type: actionTypes.ADD_LOADER,
          loaderName: 'PAGE_LOADER',
        });
        setAnchorEl2(null);
        const updateSchemaPayload = {
          selected_schema: schemaName,
        };
        await restApi.post(`/switch_account`, updateSchemaPayload);
        localStorage.removeItem('contentrecommendation-listpage-filters');
        sessionStorage.removeItem('contentrecommendation-listpage-filters');
        localStorage.removeItem('content-recommendations-urls');
        Object.keys(localStorage).forEach(
          (key) => key.includes('reprocessModalSkipped') && localStorage.removeItem(key)
        );
        localStorage.setItem('switched_account', Date.now().toString());
        window.location.reload();
      } catch (error) {
        console.error('Header :: changeSchema: unable to update Looker schema');
      } finally {
        dispatch({
          type: actionTypes.REMOVE_LOADER,
          loaderName: 'PAGE_LOADER',
        });
      }
    },
    [dispatch]
  );

  const renderSchemaSelectors = useMemo(() => {
    if (schemaList.length <= 1) {
      return <></>;
    }

    return (
      <>
        <Divider />
        <MenuItem className="list-section-header cur-unset">Switch Accounts</MenuItem>
        {(accountsList || []).map((account, idx) => (
          <React.Fragment key={idx}>
            {account.listItems ? (
              <CollapsibleListItem
                {...account}
                includeParent
                onClick={(acc) => changeSchema(acc.cust_code)}
                childKey="cust_child_name"
                listItemClassName="dropdown-menu"
                AddOn={({ additionProps }) => (
                  <img src={getLogo(appendHttpsIfNotPresent(additionProps?.domain_url), 64)} />
                )}
              />
            ) : (
              <ListItem className="dropdown-menu" onClick={() => changeSchema(account.cust_code)}>
                <img src={getLogo(appendHttpsIfNotPresent(account?.domain_url), 64)} />
                {account.cust_name}
                {account.cust_child_name ? ' ' + account.cust_child_name : null}
              </ListItem>
            )}
          </React.Fragment>
        ))}
      </>
    );
  }, [accountsList, schemaList.length]);

  useEffect(() => {
    setDefaultUser(props.defaultUser);
  }, [props.defaultUser, props.getUserType, changeSchema, dispatch]);

  const analyticsEvent = (value) => {
    if (window.analytics) {
      window.analytics.track(`Switched to ${value} Dashboard`);
    } else {
      segmentEventApi(
        `Switched to ${value} Dashboard`,
        {
          option: value,
        },
        'track'
      );
    }
  };

  return (
    <>
      <AppBar className={isEnterpriseUser ? 'app-bar' : 'app-bar-with-q-logo'}>
        {props.SubscriberBanner ? <>{props.SubscriberBanner}</> : null}
        <Toolbar style={{ justifyContent: 'space-between' /*need to change */ }}>
          <div id="layout__div__header_0" style={{ display: 'inline-flex' /*need to change */ }}>
            {props.isMobile && (
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                style={{ zIndex: 1 }}
              >
                <MenuIcon />
              </IconButton>
            )}
            {props.isMobile ? (
              <img
                className="q-header-logo"
                src={isEnterpriseUser ? QLogo.src : '/Quattr-Q-logo.png'}
                alt="Quattr logo"
              />
            ) : (
              <img
                className="q-header-logo"
                src={isEnterpriseUser ? QLogo.src : '/Quattr-Q-logo-desktop.svg'}
                alt="Quattr logo"
              />
            )}

            <div className="q-logo-dropdown-container">
              {!isEnterpriseUser && !props.isMobile ? (
                <FormDropDown
                  key={defaultUser}
                  id="opportunities__fromdropdown__opportunity_explorer_27"
                  defaultValue={defaultUser}
                  onChange={(e) => {
                    props?.handleUserToggle(e.target.value);
                    analyticsEvent(e.target.value);
                  }}
                  options={props?.options}
                  className="simple-dropdown-header"
                  style={{
                    margin: 0,
                    padding: 0,
                    height: '35px',
                    background: '#ffff',
                    borderRadius: '4px !important',
                    fontSize: '14px',
                  }}
                  fullWidth
                  downArrowChange={'down-arrow-change'}
                  sessionUserType={props?.getUserType}
                />
              ) : null}
            </div>

            {filter && filter.filters && showDatePicker && !props.isMobile ? (
              <DateRangePicker
                class={'date-picker-theme-color'}
                isHeader={true}
                setDateRanges={setDateRanges}
                onChange={(res, showDatePicker) => updateDatePickerParams(res, showDatePicker)}
                userSelectedDateRange={userSelectedDateRange}
                defaultSecondPickerVisible={filter.filters['is_date_comparison'] == 'Yes'}
                defaultSelected={
                  filter.isTopTrendDetails
                    ? CUSTOM_RANGE
                    : filter.isPersisitedFilters
                    ? filter.dateRanges.selected
                    : null
                }
                key={dateRangekey}
                isRankingFactor={filter.isRankingFactor}
                isTopTrendDetails={filter.isTopTrendDetails}
                defaultDateRange={{
                  startDate1: filter.dateRanges.selected.startDate,
                  endDate1: filter.dateRanges.selected.endDate,
                  startDate2: filter.dateRanges.comparison.startDate,
                  endDate2: filter.dateRanges.comparison.endDate,
                }}
              />
            ) : null}
          </div>
          {!props.isMobile && showBreadCrumb && (
            <div className="breadcrumb-wrapper white">
              <Breadcrumbs separator={<ArrowRight />} aria-label="breadcrumb">
                <Typography color="textPrimary">Ad-hoc Analysis</Typography>
                {containsDynamicRoute ? (
                  <Link color="inherit" href={RemoveLastUrlPartOf(pathname, 2)}>
                    {breadcrumbMeta[pathname.split('/')[3]]}
                  </Link>
                ) : (
                  <Typography color="textPrimary">{breadcrumbMeta[pathname.split('/')[3]]}</Typography>
                )}
                {dynamicRouteTitle && <Typography color="textPrimary">{dynamicRouteTitle}</Typography>}
              </Breadcrumbs>
            </div>
          )}

          <div>
            {props?.getUserType !== USER_CLASSIFICATION.QWA_TOOLS ? (
              <div className={`popup-button customer-switch-btn-white-bg`}>
                <Button
                  id="layout__button__header_1"
                  className="pr-0"
                  disableRipple
                  onClick={handleDropDownclickSchema}
                >
                  {showCustomerInfo && schemaList ? (
                    <>
                      {/* <img
                        src={`${GOOGLE_FETCH_FAVICON_API}?domain=${appendHttpsIfNotPresent(
                          customerInfo[schemaIndex].domain_url
                        )}`}
                      /> */}
                      <img src={getLogo(appendHttpsIfNotPresent(customerInfo[schemaIndex].domain_url), 64)} />
                      {!props.isMobile && (
                        <div>
                          <div style={{ whiteSpace: 'nowrap' }}>{customerInfo[schemaIndex].cust_name}</div>
                          {customerInfo[schemaIndex].cust_child_name && (
                            <div className="grey-secondary-text">
                              <b>{customerInfo[schemaIndex].cust_child_name}</b>
                            </div>
                          )}
                        </div>
                      )}
                    </>
                  ) : (
                    <>
                      <Skeleton variant="circle" width={40} height={40} />
                      <Skeleton className="ml-5" variant="rect" width={70} height={15} />
                    </>
                  )}
                  <Avatar
                    className={` ${
                      props?.getUserType === USER_CLASSIFICATION.QWA_TOOLS ? 'q-avatar-white' : 'q-avatar'
                    }`}
                  >
                    {getAvatarInitials(userName)}
                  </Avatar>
                </Button>
              </div>
            ) : (
              <Avatar className="q-avatar-white" onClick={handleDropDownclickSchema}>
                {getAvatarInitials(userName)}
              </Avatar>
            )}
          </div>

          <Popover
            open={openSchema}
            anchorEl={anchorEl2}
            onClose={() => setAnchorEl2(null)}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            className="popup-with-list"
            transformOrigin={{
              vertical: 'top',
              horizontal: 'left',
            }}
          >
            <div className="align-items-Center pd-tb-10">
              <MenuItem className="user-name cur-unset">
                <b>{userName}</b>
              </MenuItem>
              {subscriberMeta?.customer_id && session?.user?.userType === USER_CLASSIFICATION.CONTENT_AI && (
                <ManageSubscriptions
                  buttonType="link"
                  customer_id={subscriberMeta?.customer_id}
                  isMenuItem
                  redirect_url={
                    process.env.NEXT_PUBLIC_HOST_URL !== 'http://localhost:3000'
                      ? `${process.env.NEXT_PUBLIC_HOST_URL}/app/content-ai-home`
                      : 'http://app-predev.quattr.com/app/content-ai-home'
                  }
                />
              )}
              {session?.user?.user_id &&
                session?.user?.userType === USER_CLASSIFICATION.QWA_TOOLS &&
                session?.user?.qwa_tools_subscription_status && (
                  <ManageSubscriptions
                    buttonType="link"
                    customer_id={session?.user?.user_id}
                    isMenuItem
                    redirect_url={
                      process.env.NEXT_PUBLIC_HOST_URL !== 'http://localhost:3000'
                        ? `${process.env.NEXT_PUBLIC_HOST_URL}/app/ai-tools-home`
                        : 'http://app-predev.quattr.com/app/ai-tools-home'
                    }
                    isToolsUser={true}
                    email={session?.user?.email}
                  />
                )}
              <MenuItem onClick={handleLogout}>Sign Out</MenuItem>
              {userType == USER_CLASSIFICATION.QWA_TOOLS &&
              props?.isMobile &&
              (props.defaultUser === USER_CLASSIFICATION.QWA_TOOLS ||
                (props.defaultUser === USER_CLASSIFICATION.CONTENT_AI &&
                  [
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_ACTIVATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_CREATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_REACTIVATED,
                    SUBSCRIPTION_STATUS.SUBSCRIPTION_RESUMED,
                  ].includes(session?.user?.qwa_tools_subscription_status as any))) ? (
                <div>
                  <Divider />
                  <div onClick={() => setAnchorEl2(null)}>
                    <CreditsComponent />
                  </div>
                </div>
              ) : null}
            </div>
            {renderSchemaSelectors}
          </Popover>
        </Toolbar>
      </AppBar>
    </>
  );
}
